import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const F_CONDITION_SCHEMA_LITERAL = {
    title: 'Schéma conditions',
    description: 'Décrit les conditions',
    version: 0,
    keyCompression: false,
    primaryKey: { key : 'CBMARQ_PK', fields : ['CBMARQ'], separator : '' },
    type: 'object',
    properties: {
        CBMARQ_PK: { type: 'string', maxLength : 10 },
        CBMARQ: { type: 'number' },
        AR_REF: { type: 'string' },
        CO_REF: { type: 'string' },
        CO_NO: { type: 'number' },
        EC_ENUMERE: { type: 'string' },
        EC_QUANTITE: { type: 'number' },
        CO_CODEBARRE: { type: 'string' },
        CO_PRINCIPAL: { type: 'number' }
    },
    required: [ 'CBMARQ', 'AR_REF', 'EC_ENUMERE', 'EC_QUANTITE' ]  
} as const;

const schemaTyped = toTypedRxJsonSchema(F_CONDITION_SCHEMA_LITERAL);
export type RxFConditionDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const F_CONDITION_SCHEMA: RxJsonSchema<RxFConditionDocumentType> = F_CONDITION_SCHEMA_LITERAL;
